














import { defineComponent, toRefs, computed, ref, getCurrentInstance } from '@vue/composition-api';
import { DialogPlugin, DialogInstance } from 'tdesign-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    users: {
      type: Array,
      default: [],
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { users } = toRefs(props);
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const defaultTeamRole = ref(users.value.length > 0 ? (users.value as CoFile.TeamMember[])[0].teamRole : 'user');
    const teamRole = ref(defaultTeamRole.value);
    const methods = {
      // 点击确定
      confirm() {
        if (teamRole.value === defaultTeamRole.value) {
          innerShow.value = false;
          return;
        }
        // 设为普通用户时弹窗二次确认
        if (teamRole.value === 'user') {
          const dialog: DialogInstance = CustomDialog.confirm({
            theme: 'warning',
            header: i18n_t('切换为普通用户'),
            body: i18n_t('切换为普通用户后，将无该团队管理权限'),
            width: '420px',
            className: 'switch-team-role-dialog',
            async onConfirm() {
              if (dialog.hide) {
                dialog.hide();
              }
              methods.submit();
            },
          });
        } else {
          methods.submit();
        }
      },
      submit() {
        context.emit('submit', {
          teamRole: teamRole.value,
          userIds: (users.value as CoFile.TeamMember[]).map(item => item.userId).join(','),
        });
      },
    };
    return {
      innerShow,
      teamRole,
      ...methods,
    };
  },
});
